// src/utils/global.js

// 定义全局变量
const globalVars = {
  // 应用配置
  appConfig: {
    appName: "建设项目管理系统",
    version: "1.0.0",
    apiBaseUrl: "http://211.136.184.90:8090",
    timeout: 10000,
  },

  // 用户信息
  userInfo: {
    isLoggedIn: false,
    userName: "",
    userId: "",
    role: "guest",
  },

  // 业务配置
  businessConfig: {
    pageSizes: [10, 20, 50, 100],
    defaultPageSize: 10,
    tableMaxHeight: "90%",
  },

  // 状态标志
  flags: {
    isLoading: false,
    isMobile: false,
  },

  // 缓存数据
  cache: {
    projectList: [],
    lastUpdateTime: null,
  },
};

// 导出默认实例
export default globalVars;
